// third-party
import { createSlice } from '@reduxjs/toolkit';
import axios from 'utils/axios';

// project imports
import { ARYABHATTA_API_DOMAIN_V1 } from 'config';
import { DEFAULT_ERROR_MESSAGE } from '../constant';
import { openSnackbar } from './snackbar';
import { dispatch } from '../index';

const initialState = {
    roomsData: null,
    currencyCode: '',
    staticData: null,
    resultsLoading: false,
    finalSelectedRecommendation: {}
};

const hhiRoomsListSlice = createSlice({
    name: 'hhiRoomsList',
    initialState,
    reducers: {
        setRoomsLoading(state, action) {
            state.resultsLoading = action.payload;
        },
        setRoomsData(state, action) {
            state.roomsData = action.payload;
        },
        setCurrencyCode(state, action) {
            state.currencyCode = action.payload;
        },
        setStaticData(state, action) {
            state.staticData = action.payload;
        },
        setFinalSelectedRecommendation(state, action) {
            if (typeof action.payload.index === 'number') {
                // eslint-disable-next-line no-prototype-builtins
                state.finalSelectedRecommendation[action.payload.index] = action.payload.data;
            }
        },
        resetHHIStore() {
            return initialState;
        }
    }
});

export const { setRoomsData, setRoomsLoading, setCurrencyCode, setStaticData, resetHHIStore, setFinalSelectedRecommendation } =
    hhiRoomsListSlice.actions;
export default hhiRoomsListSlice.reducer;

export const getRoomsList = ({ payload, hotelId, traceId, onSuccess = () => {}, onError = () => {} }) => {
    const url = `${ARYABHATTA_API_DOMAIN_V1}hhi/hotels/${hotelId}/room-list`;

    const { checkIn, checkOut, occupancies, destinationCode, requirement_code: requirementCode } = payload;

    const reqBody = {
        traceId,
        checkIn,
        checkOut,
        occupancies,
        destinationCode,
        hotelId,
        requirement_code: requirementCode
    };

    return async () => {
        try {
            dispatch(setRoomsLoading(true));

            const response = await axios.post(url, reqBody, {
                headers: { source: 'mweb' }
            });
            const { data = {} } = response || {};
            const { results = [] } = data || {};
            const { data: hotelData = {} } = results?.[0] || {};
            const { currencyCode = '', staticData = {} } = hotelData || {};
            const finalData = {
                results: [{ data: [hotelData] }]
            };
            dispatch(setRoomsData(finalData));
            dispatch(setRoomsLoading(false));
            onSuccess(finalData);
            dispatch(setCurrencyCode(currencyCode));
            dispatch(setStaticData(staticData));
        } catch (error) {
            onError(error);
            dispatch(
                openSnackbar({
                    open: true,
                    message: DEFAULT_ERROR_MESSAGE,
                    variant: 'alert',
                    alert: { color: 'error' },
                    close: false
                })
            );
            dispatch(setRoomsLoading(false));
        }
    };
};
